import React, { useEffect, useState } from 'react'
import search from '../../../Assets/home2/search.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import image from '../../../Assets/vehicle/image.png'
import prev from '../../../Assets/vehicle/prev.svg'
import next from '../../../Assets/vehicle/next.svg'
import img1 from '../../../Assets/add/img1.png'
import icon1 from '../../../Assets/vehicle/icon1.svg'
import icon2 from '../../../Assets/add/icon2.svg'
import icon3 from '../../../Assets/add/icon3.svg'
import img3 from '../../../Assets/add/img3.png'
import img6 from '../../../Assets/add/img6.png'
import img7 from '../../../Assets/add/img7.png'
import img2 from '../../../Assets/add/img2.png'
import img2profile from '../../../Assets/profile/img2.png'
import icon7 from '../../../Assets/crane/icon7.svg'
import icon6 from '../../../Assets/crane/icon6.svg'
import icon8 from '../../../Assets/crane/icon8.svg'
import icon9 from '../../../Assets/crane/icon9.svg'
import icon10 from '../../../Assets/crane/icon10.svg'
import icon11 from '../../../Assets/crane/icon11.svg'

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AddBoxIcon from '@mui/icons-material/AddBox';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import allAccidentVehicleImg from '../../../Assets/allAccidentVehicle.jpg'
import fleetvehicles from '../../../Assets/fleetvehicles.jpg'
import allvehiclestruck from '../../../Assets/allvehiclestruck.png'
import crossUser from '../../../Assets/crossUser.png'
import checksuccess from '../../../Assets/checksuccess.png'
import processImgUser from '../../../Assets/processImgUser.png'
import BottomNavigationBar from '../../../Component/Customers/BottomNavigationBar.jsx';
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import AddNewData from '../../../Component/Customers/Cards/AddNewData.jsx';
import LookingForAccptance from '../Registration/LookingForAcceptance.jsx';
import { Truck, Plane, Scale, Wrench, Building2, MapPin, Star, Clock, Shield, ChevronDown } from 'lucide-react';

const accidentVehicles = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
    { id: 9 },
]

const registeredVehicles = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
    { id: 9 },
    { id: 10 },
    { id: 11 },
    { id: 12 },
]

function CategoryPill({ icon: Icon, label, isActive, onClick }) {
    return (
        <button
            className={`flex items-center space-x-2 px-3 py-1 rounded-full ${isActive ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800'
                } hover:bg-blue-500 transition-colors`}
            onClick={onClick}
        >
            <Icon className="w-5 h-5" />
            <span className='text-[10px]'>{label}</span>
        </button>
    );
}

function AllVehicle() {
    const [hBtn, setHBtn] = useState("Accident Vehicles");
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [isModalOpen3, setIsModalOpen3] = useState(false);
    const [accidentPage, setAccidentPage] = useState(1);
    const [registeredPage, setRegisteredPage] = useState(1);
    const itemsPerPage = 6;

    // Current Page & Data Based on Tab
    const currentPage = hBtn === "Accident Vehicles" ? accidentPage : registeredPage;
    const data2 = hBtn === "Accident Vehicles" ? accidentVehicles : registeredVehicles;
    const totalPages = Math.ceil(data2.length / itemsPerPage);

    // Get Paginated Items
    const currentItems = data2.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    // Page Change Handler
    const handlePageChange = (newPage) => {
        if (hBtn === "Accident Vehicles") {
            setAccidentPage(newPage);
        } else {
            setRegisteredPage(newPage);
        }
    };

    const [data, setData] = useState([]);
    const [activeCategory, setActiveCategory] = useState('all');

    const [accidentData, setAccidentData] = useState([]);
    const [filtering, setFiltering] = useState([]);

    const [notAccidentVehicleData, setNotAccidentVehicleData] = useState([]);
    const [accidentVehicleData, setAccidentVehicleData] = useState([]);


    const [currentItem, setCurrentItem] = useState([]);
    const [viewDetails, setViewDetails] = useState(false);
    const [caseDetailsHere, setCaseDetailsHere] = useState(false);
    const [viewAllVendors, setViewAllVendors] = useState(false);

    const [doneFetching, setDoneFetching] = useState(false)
    const [doneFetching2, setDoneFetching2] = useState(false)
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [filter, setFilter] = useState('')
    // const currentService = 'crane'



    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const navigate = useNavigate()

    const getFilteredData = (filter) => {
        console.log("data is here");
        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));




        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        console.log("todayDate", todayDate)
        console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < accidentData.length; i++) {
            console.log('accidentData[i]?.systemDate.split', accidentData[i]?.[activeCategory !== 'all' ? `${activeCategory}Details` : 'craneDetails']?.systemDate?.split('T'))
            console.log('accidentData[i]?.systemDate.split', accidentData[0]?.[activeCategory !== 'all' ? `${activeCategory}Details` : 'craneDetails']?.systemDate?.split('T'))
            let getTime = accidentData[i]?.[`${activeCategory}Details`]?.systemDate.split('T');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            console.log('assignedate', getTime[0], getTime[1])
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                console.log("here i am daily")
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(accidentData[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                console.log("here i am weekly")
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(accidentData[i]);
                }
            }
            else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(accidentData[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    console.log("Match found within last year:", accidentData[i]);
                    filteredData.push(accidentData[i]);
                }
            }
        }
        if (filter === 'newest') {
            console.log("Sorting by newest to oldest");
            accidentData.sort((a, b) => {
                const dateA = new Date(a?.systemDate.split('T').join(' '));
                const dateB = new Date(b?.systemDate.split('T').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...accidentData]);
        } else if (filter === 'oldest') {
            console.log("Sorting by oldest to newest");
            accidentData.sort((a, b) => {
                const dateA = new Date(a?.systemDate.split('T').join(' '));
                const dateB = new Date(b?.systemDate.split('T').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...accidentData]);
        }
        else {
            setData(filteredData)
        }
    };

    useEffect(() => {
        getData();
        getAccidentData()
        getSomeInfo();

        console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }
    }, [token, userId, navigate]);

    const goToNewCase = () => {

        navigate("/register-new-accidentvehicle", { state: { fromPageHere: "allVehicles", vehicleNo: currentItem.vehicleNo } })
    }

    const getSomeInfo = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/testing-websocket`);
        console.log("responsefrom", response.data)
    }

    const getData = async (e) => {
        console.log("userid", userId);
        let accidentVehicles = [], notAccidentVehicles = []
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getFilteredPersonalVehicle/${userId}`);
        if (response.data.message === "No accident vehicle data found.") {
            setData([])
            setDoneFetching(true)
        }
        else {
            console.log("response123421", response.data.data);
            response.data.data.map((item) => {
                if (item.alreadyAccidentVehicle === true) accidentVehicles.push(item)
                if (item.alreadyAccidentVehicle === false) notAccidentVehicles.push(item)

            })
            console.log("seTDATIOATN", response.data.data);
            setFiltering(accidentVehicles)
            setData(accidentVehicles)
            setNotAccidentVehicleData(notAccidentVehicles)
            setAccidentVehicleData(accidentVehicles)
            setDoneFetching(true)
        }
    };

    const getAccidentData = async (e) => {
        try {
            console.log("userid", userId);
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/not_defined/not-completed`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            console.log('responsead', response)
            if (response.data.message == "No accident vehicle data found.") {
                setAccidentData([])
                setDoneFetching2(true)
            }
            else {
                console.log('response.data.data', response.data.data)
                response.data.data.map((item) => {
                    console.log("item.customer.confirmDoneWorking", item.customer.confirmDoneWorking)
                    if (!item.customer.confirmDoneWorking) {
                        setAccidentData((prev) => [...prev, item])
                    }
                })
                // setAccidentData(response.data.data)
                setDoneFetching2(true)
                console.log("ACcidenData", accidentData)
            }
        }
        catch (error) {
            if (error.response && error.response.status === 404 && error.response.data.message == "No accident vehicle data found.") {
                console.log('cathc')
                setAccidentData([]);
                setDoneFetching2(true);
            } else {
                console.error("Unexpected error:", error);
            }
        }
    }


    const setDetails = (item) => {
        setViewDetails(true)
        setCurrentItem(item)
    }

    const setUpdateAccidentData = (item) => {
        setCaseDetailsHere(true)
        const gotItem = accidentData.find((accidentItem) => {
            console.log('item', item)
            console.log('accidentItem', accidentItem)
            return (accidentItem?.vehicle?.AccidentVehicleCode == item.AccidentVehicleCode)
        })
        console.log("GOTITEM", gotItem)

        let gotInfo = {
            ...gotItem?.vehicle,
            accidentImage1: gotItem?.vehicle?.accidentImage1,
            accidentImage2: gotItem?.vehicle?.accidentImage2,
            accidentImage3: gotItem?.vehicle?.accidentImage3,
            accidentImage4: gotItem?.vehicle?.accidentImage4,
        };
        console.log('gotinfo', gotInfo)
        setCurrentItem(gotInfo)
    }

    const setViewVendors = (item) => {
        setViewAllVendors(true)
        const gotItem = accidentData.find((accidentItem) => {
            return (accidentItem?.vehicle.AccidentVehicleCode === item.AccidentVehicleCode)
        })
        console.log("hey", gotItem.customer)
        console.log("gotitemd12312312", gotItem)
        setCurrentItem(gotItem.customer)
    }

    const handleUpdate = () => {
        setCaseDetailsHere(false)
    };

    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchValue(value);
        const newRows = filtering.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly

            const idValue = formattedId.includes(searchLower);
            const vehicleNoValue = (row.vehicleNo ?? '').toLowerCase().includes(searchLower);
            const chassisNoValue = (row.chassisNo ?? '').toLowerCase().includes(searchLower);

            return vehicleNoValue || chassisNoValue;
        });

        setData(newRows);
    };
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleSelect = (index) => {
        setSelectedIndex(index);
        index === 0 ? setFiltering(accidentVehicleData) : setFiltering(notAccidentVehicleData)
        index === 0 ? setData(accidentVehicleData) : setData(notAccidentVehicleData)
    };

    const getOnPage = (service) => {
        console.log("SOME", service, currentItem.customerAcceptedVendor)
        if (currentItem?.customerAcceptedVendor == true && currentItem.confirmDoneWorking == false) navigate("/Crane-dashboard/tracking", { state: { indexFor: 0, service: service, vehicleNumber: currentItem.reg } })
        else if (currentItem?.customerAcceptedVendor == false) navigate("/Crane-dashboard/quotationupdate", { state: { indexFor: 1, service: service, vehicleNumber: currentItem.reg } })
        else if (currentItem?.customerAcceptedVendor == true && currentItem.confirmDoneWorking == true) navigate("/Crane-dashboard/history", { state: { indexFor: 2, service: service, vehicleNumber: currentItem.reg } })
    }

    const settingFilter = (filter) => {
        console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }
    const navigateToNewVehicle = () => {
        navigate("/add-new-vehicle-driver")
    }

    const navigateToPage = () => {
        selectedIndex == 1 ? navigate("/add-new-vehicle-driver") : navigate('/register-new-accidentvehicle')
    }
    const [updatedData, setUpdatedData] = useState(false);
    console.log('updatedata123', updatedData)
    useEffect(() => {
        if (updatedData) {
            console.log('setUpdatedDat123a', updatedData)
            getData();
            getAccidentData();
            setCaseDetailsHere(false)
            setUpdatedData(false)
        }
    }, [updatedData])

    useEffect(() => {
        console.log('activeCategory', activeCategory)
        console.log('data1', accidentVehicleData)
        if (activeCategory == 'all') {
            setData(accidentVehicleData);
            return;
        }
        const getActiveCategory = accidentVehicleData.filter((item) => {
            console.log('item1', item)
            const selectedOptions1 = item.selectedOptions.split(',')
            console.log('selectedoption', selectedOptions1)
            return selectedOptions1.some((option) => {
                console.log('item[`${option}Status`] ! && option === activeCategory', item[`${option}Status`], 'cancelled', option, activeCategory)
                return item[`${option}Status`] !== 'cancelled' && option === activeCategory
            })

            //     const arrayItem = item.selectedOptions.split(',')
            //    if( item.selectedOptions.includes(activeCategory)){
            //     console.log('item2', item)
            //      return item;
            //     }
        })
        setData(getActiveCategory)
    }, [activeCategory])

    return (
        <>
            <div className='vehicle-section'>
                <h6 className="font-[700] text-center font-satoshi text-[61px] leading-[68px] text-[#FFFFFF] pt-[52px] mb-0 pb-[72px]">
                    All  Vehicles</h6>
                <div style={{ backdropFilter: "blur(20px)" }} className="flex bg-[#FFFFFF4D] max-w-[736px] w-full mx-auto py-[28px] rounded-[66px] pl-[40px] mb-[78px] pr-[28px] items-center justify-between">
                    <input type="text" className='outline-none bg-transparent text-[#FFFFFF] placeholder:text-[#FFFFFF] font-[500] text-[16px] leading-[20px]' placeholder='Search By Service' />
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home2/search.svg' className='h-[30px] w-[30px]' alt="" />
                </div>
            </div>
            {doneFetching2 && doneFetching && (
                <div className='md:px-[80px] px-[20px] bg-white'>
                    <div className="flex md:flex-row flex-col justify-between items-center pb-[66px]">
                        <div className="flex items-center gap-[12px] w-full">
                            <button onClick={() => handleSelect(0)} className={`rounded-[92px] font-satoshi text-[16px] border-[1px] py-[14px] max-w-[202px] w-full ${selectedIndex === 0 ? "bg-[#21A6E9] text-[#FFFFFF] border-[#E7E4FC] font-[700]" : "bg-[#FFFFFF] text-[#000000] border-[#E7E4FC] font-[400]"}`}>Accident Vehicles {` (${accidentVehicleData?.length})`}</button>
                            <button onClick={() => handleSelect(1)} className={`rounded-[92px] font-satoshi text-[16px] border-[1px] py-[14px] max-w-[202px] w-full ${selectedIndex === 1 ? "bg-[#21A6E9] text-[#FFFFFF] border-[#E7E4FC] font-[700]" : "bg-[#FFFFFF] text-[#000000] border-[#E7E4FC] font-[400]"}`}>Registered Vehicles ({notAccidentVehicleData?.length})</button>
                        </div>
                        <div className="flex justify-end gap-[24px] items-center w-full">
                            <button>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vehicle/icon1.svg' alt="" />
                            </button>
                            <div className="bg-[#21A6E9] flex items-center max-w-[260px] justify-between w-full py-[5px] rounded-full pr-[6px] pl-[26px] cursor-pointer">
                                <button className="font-satoshi font-[400] text-[24px] leading-[33.6px] pr-[8px] text-[#FFFFFF]">Add New Vehicle</button>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                            </div>
                        </div>
                    </div>

                    <div>
                        {selectedIndex == 0 && (
                            <div className="px-4 mb-6 mt-4">
                                <div className="flex flex-wrap space-x-2 gap-2 pb-2 scrollbar-hide max-full ">
                                    {[
                                        { icon: Truck, label: "All Cases", category: "all" },
                                        { icon: Truck, label: "Recovery", category: "recoveryVan" },
                                        { icon: PrecisionManufacturingIcon, label: "Crane", category: "crane" },
                                        { icon: Scale, label: "Legal", category: "advocate" },
                                        { icon: Wrench, label: "Repairs", category: "repairs" },
                                        { icon: Building2, label: "Workshops", category: "workshops" }
                                    ].map((item) => (
                                        <CategoryPill
                                            key={item.category}
                                            icon={item.icon}
                                            label={item.label}
                                            isActive={activeCategory === item.category}
                                            onClick={() => setActiveCategory(item.category)}
                                            className="text-xs px-2 py-1 w-auto mt-1"
                                        />
                                    ))}
                                </div>

                            </div>)}

                        {data.length > 0 && (
                            <div className="grid md:grid-cols-3 grid-cols-1 gap-[27px]">
                                {data.map((item, index) => (
                                    <div key={index}>
                                        <div className='bg-[#F9F9F9] border-[1px] border-[#E7E4FC] rounded-[16px]'>
                                            <div className='relative'>
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vehicle/image.png' alt="" />
                                                <h6 className="m-0 absolute bottom-[20px] left-[30px] font-[700] font-satoshi text-[24px] text-[#FFFFFF]">Ashok Leyland</h6>
                                            </div>
                                            <div className='py-[27px] px-[30px]'>
                                                <div className="grid sm:grid-cols-2 gap-y-[20px] pb-[27px]">
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[20px] text-[#0A0119] pb-[6px]">{item.vehicleNo}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[20px] text-[#0A0119] pb-[6px]">{item.chassisNo}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Chassis No</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[20px] text-[#0A0119] pb-[6px]">12/02/2023</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Accident Date</p>
                                                    </div>
                                                </div>
                                                {selectedIndex === 0 && (<div className="flex flex-col gap-[10px]">
                                                    <button className='py-[10px] text-center w-full text-[#FFFFFF] font-satoshi font-[400] text-[24px] leading-[33.6px] bg-[#21A6E9] border-[1px] border-[#FFFFFF] rounded-full' onClick={() => setUpdateAccidentData(item)}>Accident Details</button>
                                                    <button className='py-[10px] text-center w-full text-[#21A6E9] font-satoshi font-[400] text-[24px] leading-[33.6px] bg-transparent border-[1px] border-[#21A6E9] rounded-full' onClick={() => setViewVendors(item)}>View Vendors</button>
                                                </div>)}
                                                {selectedIndex == 1 && (<div className="flex flex-col gap-[10px]">
                                                    <button className='py-[10px] text-center w-full text-[#FFFFFF] font-satoshi font-[400] text-[24px] leading-[33.6px] bg-[#21A6E9] border-[1px] border-[#FFFFFF] rounded-full' onClick={() => setDetails(item)}>View Details</button>
                                                </div>)}

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {data.length === 0 && (
                            // <NoDataFound />
                            <div onClick={navigateToPage}>
                                <AddNewData index={selectedIndex} />
                            </div>
                        )}
                    </div>
                    {caseDetailsHere && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001]">
                            <div className="bg-white py-[27px] h-[800px] md:px-[48px] px-[20px] rounded-[30px] shadow-lg w-[90%] overflow-y-scroll md:w-[1148px]">
                                <div className="flex justify-between items-center">
                                    <h6 className="m-0 font-[500] font-satoshi text-[31px] text-[#000000]">View Accident Details</h6>
                                    <img onClick={() => setCaseDetailsHere(false)} src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='h-[35px] w-[35px]' alt="" />
                                </div>

                                <LookingForAccptance accidentData={currentItem} setUpdatedData={setUpdatedData} fromPage="AllVehicles" />
                            </div>
                        </div>)}
                    {viewDetails && (
                        <div className="mt-[400px] mb-[500px] fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001]">
                            <div className="bg-white py-[27px] h-[800px] md:px-[48px] px-[20px] rounded-[30px] shadow-lg w-[90%] overflow-y-scroll md:w-[1148px]">
                                <div className="flex justify-between items-center">
                                    <h6 className="m-0 font-[500] font-satoshi text-[31px] text-[#000000]">View Registered Vehicle Details</h6>
                                    <img onClick={() => setViewDetails(false)} src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='h-[35px] w-[35px]' alt="" />
                                </div>
                                <div className="flex md:flex-row flex-col justify-center gap-[30px] pt-[44px]">
                                    <div className="max-w-[614px] w-full bg-[#FFFFFF]">
                                        <div className="flex flex-col gap-[24px]">
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Vehicle No  </label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.vehicleNo} placeholder='Enter No' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Chassis No</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.chassisNo} placeholder='Enter No' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Engine Number</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.engineNo} placeholder='Enter Number' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Make Of Vehicle</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.make} placeholder='Enter Make' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Model Of Vehicle</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.model} placeholder='Enter Model' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Year Of Vehicle</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.year} placeholder='Enter Year' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Type Of Vehicle</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.type} placeholder='Enter Type' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Application Of Vehicle</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.application} placeholder='Enter Application' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Insurance Of Vehicle</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} id="" value={currentItem.InsuranceName} placeholder='Insurance Of Vehicle' />
                                                </div>
                                            </div>
                                        </div>
                                        <h6 className="m-0 font-[500] font-satoshi text-[31px] text-[#000000] py-[15px]">Driver Details</h6>
                                        <div className="flex flex-col gap-[24px]">
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Driver Name</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} value={currentItems.driverName} id="" placeholder='' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Driver Number</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} value={currentItems.driverNumber} id="" placeholder='' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Driver Email</label>
                                                <div>
                                                    <input type="text" name="" className='border border-[#DEDEE8] placeholder:text-[#555454] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }} value={currentItems.driverEmail} id="" placeholder='' />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Operator License Copy</label>
                                                <div>
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/img2.png' alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='w-full max-w-[555px]'>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img2.png' className='w-full h-[400px]' alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {viewAllVendors && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
                            <div className="bg-white pt-[27px] pb-[60px] md:px-[48px] px-[20px] rounded-[30px] shadow-lg w-[90%] overflow-y-scroll md:w-[1148px]">
                                <div className="flex justify-between items-center">
                                    <h6 className="m-0 font-[500] font-satoshi text-[31px] text-[#000000]">View Vendors</h6>
                                    <img onClick={() => { setViewAllVendors(false) }} src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='h-[35px] w-[35px]' alt="" />
                                </div>
                                <div style={{ textAlign: "center", margin: "30px 0", flexDirection: "column", display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                    {currentItem.selectedOptions.split(",").map((item) => {
                                        return (
                                            <div>
                                                {currentItem[`${item}Status`] !== 'cancelled' && (
                                                    <div
                                                        key={item}
                                                        onClick={() => { getOnPage(item) }}
                                                        className='flex justify-between py-2 my-2 items-center py-[10px] text-center w-full min-w-[300px] text-[#FFFFFF] font-satoshi font-[400] text-[24px] leading-[33.6px] bg-[#21A6E9] border-[1px] border-[#FFFFFF] rounded-full px-4 cursor-pointer'
                                                    >
                                                        <p>{item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}</p>
                                                        {currentItem?.[`${item}Details`]?.confirmDoneWorking === true ? (
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png' style={{ height: "20px", width: "20px" }} />
                                                        ) : (
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/processImgUser.png' style={{ height: "20px", width: "20px" }} />
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                        )
                                    })}

                                </div>

                            </div>
                        </div>
                    )}
                    <Modal isOpen={openFilterModal} onClose={() => setOpenFilterModal(!openFilterModal)}>
                        {openFilterModal && (
                            <div style={{ textAlign: "center", marginTop: "30px", flexDirection: "column", display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('newest') }}>newest to oldest</p>
                                <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('oldest') }}>oldest to newest</p>
                                <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('daily') }}>Yesterday</p>
                                <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('weekly') }}>Last 7 days</p>
                                <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('monthly') }}>Last 30 days</p>
                                <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('year') }}>Year</p>
                            </div>
                        )}
                    </Modal>
                </div>)}
        </>
    )
}

export default AllVehicle



